<template>
	<div class="flex flex_between">
		<md-field>
			<label>{{ $t("debtorManagement.debtorData.searchDebtor") }}</label>
			<TbSelect
				v-model="moduleValue"
				@md-selected="onSelect"
				:search-allow="true"
				:search-debounce="400"
				:search-min-length="2"
				:options="options"
				options-value-field="displayValue"
				options-display-field="displayValue"
				:search-custom="true"
				@search="searchDebtor"
				:no-entries-text="$t('common.select.searchRequired')"
				:disabled="disabled"
				ref="debtorSearch"
			/>
		</md-field>
	</div>
</template>
<script>
import {debtorManagementApi} from "@/common/api/debtorManagementApi";

export default {
	props: {
		labelText: { type: String, default: "value" },
		value: { type: [Object, String], default: "" },
		disabled: { type: Boolean, default: false }
	},
	data() {
		return {
			moduleValue: "",
			options: [],
		};
	},
	methods: {
		searchDebtor(searchValue) {
			debtorManagementApi.inspection.debtorSearch({ name: searchValue })
				.then(res => {
					this.options = res.map(item => {
						return {
							...item,
							displayValue: item.name + " - " + item.address.city + (item.registrationNum ? "(" + item.registrationNum + ")" : "")
						};
					});
				})
				.catch(this.toast);
		},
		resetDebtor() {
			this.moduleValue = "";
			this.options = [];
			this.$refs.debtorSearch.resetSearch();
			this.$emit("input", null);
		},
		onSelect() {
			this.$emit("input", this.options.find(option => option.displayValue === this.moduleValue));
		},
	}
};
</script>